import type { ReactNode } from 'react';

export const symbol_circles_ext: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M123.5-163.5Q80-207 80-270t43.5-106.5Q167-420 230-420t106.5 43.5Q380-333 380-270t-43.5 106.5Q293-120 230-120t-106.5-43.5Zm501 0Q581-207 581-270t43.5-106.5Q668-420 731-420t106.5 43.5Q881-333 881-270t-43.5 106.5Q794-120 731-120t-106.5-43.5ZM230-180q38 0 64-26t26-64q0-38-26-64t-64-26q-38 0-64 26t-26 64q0 38 26 64t64 26Zm501 0q38 0 64-26t26-64q0-38-26-64t-64-26q-38 0-64 26t-26 64q0 38 26 64t64 26ZM431.5-386.5Q411-407 411-436t20.5-49.5Q452-506 481-506t49.5 20.5Q551-465 551-436t-20.5 49.5Q510-366 481-366t-49.5-20.5Zm-57-237Q331-667 331-730t43.5-106.5Q418-880 481-880t106.5 43.5Q631-793 631-730t-43.5 106.5Q544-580 481-580t-106.5-43.5ZM545-666q26-26 26-64t-26-64q-26-26-64-26t-64 26q-26 26-26 64t26 64q26 26 64 26t64-26Zm-64-64ZM230-270Zm501 0Z"
		/>
	</svg>
);
